<template>
	<div class="upRightT ">
		<div class="itemTitleBox disStart">
			<span class="title">首页底部广告</span>
		</div>
		<div class="listBox disCenter">
			<div class="picBox disStart">
				<div class="picL boxShaw disCenter">
					<div v-if="obj.imgobj5.pictureUrl" class="imgBox">
						<img :src="$basImgUrl+obj.imgobj5.pictureUrl" class="avatar">
						<span class="delIcon" @click.stop="delImg(obj.imgobj5,5)"></span>
					</div>
					<el-upload v-else class="itemBox avatar-uploader disCenter" :data="{pictureType: 5,pictureIndex: 1}"
						:headers="headers" :action="url"
						:show-file-list="false" :on-success="handleAvatarSuccess5">
						+广告图片
					</el-upload>
				</div>
			</div>
		</div>

	</div>
</template>
<script type="text/javascript">
	import ajax,{upLoadimg} from '../../../../../common/js/ajax.js'
	var token = localStorage.getItem('token')
	export default {
		name: "upRightT",
		data() {
			return {
				headers: {
					Authorization: token,
					token: token
				},
				url:upLoadimg,
				obj: {
					imgobj5: {
						advertisementId: "",
						pictureIndex: 1,
						pictureUrl: ""
					},
				},
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.getlistProjectAdvertisementByPictureType(5)
			})
		},
		methods: {
			delImg(item, n) {
				this.$api.deleteProjectAdvertisement({
					advertisementId: item.advertisementId
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n == 5) {
							this.$set(this.obj, "imgobj5", {
								advertisementId: "",
								pictureIndex: 1,
								pictureUrl: ""
							})
						}
					}
				})
			},
			getData() {},
			handleAvatarSuccess5(res, file, fileList) {
				this.getlistProjectAdvertisementByPictureType(5)
			},
			// 获取首页banner图
			getlistProjectAdvertisementByPictureType(n) {
				this.$api.listProjectAdvertisementByPictureType({
					pictureType: n
				}).then((res) => {
					if (res.returnCode == 200) {
						if (n == 5) {
							this.$set(this.obj, "imgobj5", res.obj[0] || {})
						}
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./upRightT.scss";
</style>
